<template>
  <AbsPopup v-if="isShow" id="ChangeCategory" title="이동할 카테고리 선택해 주세요" type="confirm" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <TabBar display="changeCategory" :list="categoryList" v-model="categoryinit" @selected="selected"/>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import TabBar from '@/components/layout/TabBar.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
    console.log(this.option.param)
    this.$http.post('/api/library/categoryList', {id: this.getwork}).then((e) => {
      console.log(e)
      if (e.success) {
        this.$emit('loading', false)
        if (e.data.length === 0) {
          this.$emit('close')
          this.confirm({
            target: '카테고리 존재하지 않습니다.',
            message: '카테고리 생성하시겠습니까?',
            icon: '148'
          }, (e) => {
            console.log(e)
            if (e.result) {
              this.$router.push({name: 'workinfo', params: {work: this.getwork}})
            }
          })
        } else {
          this.isShow = true
          this.categoryList = []
          for (var i = 0; i < e.data.length; i++) {
            e.data[i].index = i
            this.categoryList.push(e.data[i])
            if (e.data[i]._id === this.getCategory) {
              this.categoryinit = i
            }
          }
        }
      } else {
      }
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  data () {
    return {
      isShow: false,
      categoryList: [],
      categoryinit: -1
    }
  },
  name: 'ChangeCategory',
  watch: {
  },
  computed: {
    getwork () {
      if (this.option.param.work) {
        return this.option.param.work._id
      } else {
        return this.option.param.book.work
      }
    },
    getCategory () {
      return this.option.param.book.category
    }
  },
  methods: {
    selected (e) {
      console.log(e)
    },
    submit () {
      var c = this.categoryList[this.categoryinit]
      this.$http.post('/api/library/bookChange', {id: this.option.param.book._id, work: c.work, category: c._id}).then((e) => {
        console.log(e)
        if (e.success) {
          this.option.param.book.work = e.data.work
          this.option.param.book.category = e.data.category
          this.$emit('submit', this.option.param.book)
        } else {
        }
      })
    }
  },
  components: {
    AbsPopup,
    TabBar
  }
}
</script>

<style scoped>
#ChangeCategory {
  padding: 10px 0;
  width: 400px;
}
.popup-body {
  display: flex;
  width: 100%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ChangeCategory.vue